import { render, staticRenderFns } from "./LogisticSummary.vue?vue&type=template&id=5acdecac"
import script from "./LogisticSummary.vue?vue&type=script&lang=js"
export * from "./LogisticSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports